export default __webpack_public_path__ + "static/logo-flat-3545efd294875721307659ab1457a4f1.svg";